import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from "i18next-browser-languagedetector";

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        lng: "sr",
        fallbackLng: 'sr',
        debug: true,
        interpolation: {
            escapeValue: false,
        },
        resources: {
            sr: {
                translation: {
                    //Search page
                    memberProfile: "Tvoje članstvo",
                    loginMember: "Prijavi se",
                    profile: "Profil",
                    login: "Uloguj se",
                    betaVersion: "Beta verzija – konstantno radimo na unapređenju aplikacije",
                    searchPageSmartAssistent: "Pametni asistent za analize",
                    searchFootballTeam: "Pretraži fudbalske klubove...",
                    ourRecommendation: "Naše preporuke",
                    searchPageFunctionality: "Kako ovo funkcioniše?",
                    step1SearchTeam: "Korak 1 - Pretraži tim",
                    enterTeamName: 'Unesi ime tima koji te zanima (npr. "Zvezda", "Partizan", "Barcelona").',
                    step2SelectMatch: "Korak 2 - Izaberi meč",
                    appShowsUpcomingMatches: "Aplikacija prikazuje predstojeće mečeve tog tima. Izaberi onaj na koji planiraš da se kladiš.",
                    step3ViewAnalysis: "Korak 3 - Pogledaj analizu",
                    aiCollectsData: "Veštačka inteligencija prikuplja podatke i analizira timove, i daje ti kratak, jasan pregled.",
                    aboutApp: "O aplikaciji",
                    privacyPolicy: "Politika privatnosti",
                    termsOfUse: "Uslovi korišćenja",
                    sendProposal: "Pošalji predlog",
                    haveSuggestion: "Imate predlog za poboljšanje?",
                    submitHere: "Pošaljite ga ovde",

                    // Upcoming matches
                    loadingUpcomingMatches: "Učitavanje nadolazećih mečeva...",
                    noUpcomingMatches: "Nema nadolazećih utakmica za izabrani klub.",
                    selectMatch: "Izaberite meč",
                    dailyLimitReached: "Dnevni limit je iskorišten. Ulogujte se za veci limit.",
                    todayLimitUsed: "Iskoristili ste danasnje limite.",

                    //Result page
                    saved: "Sačuvano",
                    save: "Sačuvaj",
                    matchAnalysis: "Analiza meča",
                    aiSummary: "AI SAŽETAK",
                    starting11: "Startnih 11:",
                    noInformation: "Nema informacija",
                    matchAbsentees: "Meč propuštaju:",
                    last5MatchesForm: "Forma poslednjih 5 utakmica:",
                    averageGoalsScored: "Prosek datih golova:",
                    averageGoalsConceded: "Prosek primljenih golova:",
                    fetchingStatistics: "Dohvatanje statistike...",
                    analyzingTeams: "Analiza timova...",
                    aiWorkingOnSummary: "Veštačka inteligencija radi na sažetku...",
                    onlyLoggedInCanSave: "Samo ulogovani korisnici mogu da sačuvaju rezultat.",

                    //Profile page
                    logoutAction: "Odjavi se",
                    userSince: "Korisnik od:",
                    savedMatches: "Sačuvani mečevi",
                    noSavedMatches: "Nema sačuvanih mečeva.",
                    confirmLogout: "Da li želiš da se odjaviš?",
                    logout: "Odjavi se",
                    yes: "Da",
                    no: "Ne",
                    fullNameProfileLeftCard: "Ime i prezime:",
                    emailProfileLeftCard: "Email:",


                    //Login
                    loginPageTitle: "Prijava članova",
                    emailRequired: "Email je obavezan",
                    passwordRequired: "Lozinka je obavezna",
                    loginFailed: "Neupešna prijava",
                    email: "Email",
                    password: "Lozinka",
                    rememberMe: "Zapamti me",
                    noAccountLogin: "Nisi član?",
                    signIn: "Prijavi se",
                    joinUs: "Učlani se",
                    register: "Registruj se",
                    noAccount: "Nemas nalog?",
                    membershipBenefitsTitle: "Zašto postati član?",
                    membershipBenefits1: "Više AI analiza svakog dana",
                    membershipBenefits2: "Obrada većeg broja podataka",
                    membershipBenefits3: "Preciznije i detaljnije analize",
                    membershipBenefits4: "Čuvanje analiza",
                    membershipBenefits5: "Pristup ekskluzivnijim funkcijama",
                    membershipBenefits6: "Postani profesionalac, učlani se",
                    loginBenefitsTitle: "Prednosti članstva",
                    loginBenefits1: "Ako si već profesionalac, prijavi se!",

                    //Registration
                    passwordMinLength: "Lozinka mora imati najmanje 6 karaktera",
                    registrationSuccess: "Uspešna registracija!",
                    becomeMember: "Postani član",
                    registration: "Registracija",
                    send: "Pošalji",
                    haveAccount: "Već si član?",
                    registrationPageLogin: "Prijavi se",
                    fullName: "Ime i prezime",
                    fullNameRequired: "Ime i prezime je obavezno",
                    fullNameMinLength: "Ime i prezime mora imati najmanje 6 karaktera",
                    join: "Učlani se",

                    //About
                    aboutApp: "O aplikaciji",
                    siguricaDescription: "Sigurica AI je pametni asistent za sportsko klađenje koji koristi veštačku inteligenciju da ti pomogne da doneseš bolje odluke.",
                    aiGuideText: "Unesi ime tima koji te zanima, izaberi meč i pogledaj kratak AI rezime sa analizom forme, statistike, izostanaka i ostalih faktora.",
                    appDisclaimer: "Aplikacija ne daje gotove tipove za klađenje, već ti pruža relevantne informacije koje možeš koristiti uz sopstvenu procenu.",
                    importantToKnow: "Važno je znati:",
                    aiDevelopmentNotice: "Sigurica AI je još uvek u razvoju. Aktivno radimo na novim funkcijama i unapređenju tačnosti analiza. Svake nedelje dodajemo nove izvore podataka, algoritme i poboljšanja kako bismo ti pružili što kvalitetniji sadržaj.",
                    aiAnalysisInfo: "Koristimo napredne modele veštačke inteligencije i obradu velikih količina podataka da bismo ti prikazali jasnu, sažetu analizu svakog meča.",
                    registeredUsersBenefits: "Registrovani korisnici dobijaju pristup većem broju analiza dnevno, kao i preciznijim uvidima i naprednim funkcijama koje nisu dostupne anonimnim korisnicima.",

                    //Predefined Page
                    mustBeLogin: "Ova premium opcija je dostupna samo za članove. Prijavi se.",
                    noMatchesToday: "Nema preporuka za danas. Dođite sutra ponovo.",
                    predefinedLeaguesAnalyticsText: "Svaki dan, uz pomoć veštačke inteligencije, analiziramo i računamo koje utakmice imaju najveću šansu za pogodak tog dana.",
                    predictability: "Predvidivost:",

                }
            },
            en: {
                translation: {
                    //Search page
                    memberProfile: "Your Membership",
                    loginMember: "Sign In",
                    profile: "Profile",
                    login: "Login",
                    betaVersion: "Beta version – we are constantly working on improving the application",
                    searchPageSmartAssistent: "Smart analysis assistant",
                    searchFootballTeam: "Search football clubs...",
                    ourRecommendation: "Our recommendation",
                    searchPageFunctionality: "How does this work?",
                    step1SearchTeam: "Step 1 - Search the team",
                    enterTeamName: 'Enter the name of the team you are interested in (e.g., "Zvezda", "Partizan", "Barcelona").',
                    step2SelectMatch: "Step 2 - Select the match",
                    appShowsUpcomingMatches: "The application shows the upcoming matches of that team. Select the one you plan to bet on.",
                    step3ViewAnalysis: "Step 3 - View the analysis",
                    aiCollectsData: "Artificial intelligence collects data and analyzes the teams, giving you a short and clear overview.",
                    aboutApp: "About the application",
                    privacyPolicy: "Privacy Policy",
                    termsOfUse: "Terms of Use",
                    sendProposal: "Send proposal",
                    haveSuggestion: "Do you have a suggestion for improvement?",
                    submitHere: "Submit it here",

                    // Upcoming matches
                    loadingUpcomingMatches: "Loading upcoming matches...",
                    noUpcomingMatches: "There are no upcoming matches for the selected club.",
                    selectMatch: "Select a match",
                    dailyLimitReached: "Daily limit reached. Log in for a higher limit.",
                    todayLimitUsed: "You have used today’s limits.",

                    //Result page
                    saved: "Saved",
                    save: "Save",
                    matchAnalysis: "Match analysis",
                    aiSummary: "AI SUMMARY",
                    starting11: "Starting 11:",
                    noInformation: "No information",
                    matchAbsentees: "Players missing from the match:",
                    last5MatchesForm: "Form in the last 5 matches:",
                    averageGoalsScored: "Average goals scored:",
                    averageGoalsConceded: "Average goals conceded:",
                    fetchingStatistics: "Fetching statistics...",
                    analyzingTeams: "Analyzing teams...",
                    aiWorkingOnSummary: "Artificial intelligence is working on the summary...",
                    onlyLoggedInCanSave: "Only logged-in users can save the result.",

                    //Profile page
                    logoutAction: "Logout",
                    userSince: "User since:",
                    savedMatches: "Saved matches",
                    noSavedMatches: "No saved matches.",
                    confirmLogout: "Do you want to log out?",
                    logout: "Logout",
                    yes: "Yes",
                    no: "No",
                    fullNameProfileLeftCard: "Full name:",
                    emailProfileLeftCard: "Email:",

                    //Login
                    loginPageTitle: "Members sign in",
                    emailRequired: "Email is required",
                    passwordRequired: "Password is required",
                    loginFailed: "Login failed",
                    email: "Email",
                    password: "Password",
                    rememberMe: "Remember me",
                    noAccountLogin: "Not a Member?",
                    joinUs: "Join Us",
                    signIn: "Sign in",
                    register: "Register",
                    noAccount: "Don't have an account?",
                    membershipBenefitsTitle: "Why become a member?",
                    membershipBenefits1: "More AI analyses every day",
                    membershipBenefits2: "Processing a larger amount of data",
                    membershipBenefits3: "More precise and detailed analyses",
                    membershipBenefits4: "Saving analyses",
                    membershipBenefits5: "Access to exclusive features",
                    membershipBenefits6: "Become a professional, become a member",
                    loginBenefitsTitle: "Membership Benefits",
                    loginBenefits1: "If you are already a professional, log in!",


                    //Registration
                    passwordMinLength: "Password must be at least 6 characters long",
                    registrationSuccess: "Registration successful!",
                    registration: "Registration",
                    becomeMember: "Become a Member",
                    send: "Send",
                    haveAccount: "Already a member?",
                    registrationPageLogin: "Sign In",
                    fullName: "Full name",
                    fullNameRequired: "Full name is required",
                    fullNameMinLength: "Full name must be at least 6 characters long",
                    join: "Join",

                    //About
                    aboutApp: "About the app",
                    siguricaDescription: "Sigurica AI is a smart assistant for sports betting that uses artificial intelligence to help you make better decisions.",
                    aiGuideText: "Enter the name of the team you are interested in, select a match, and view a short AI summary with analysis of form, statistics, absences, and other factors.",
                    appDisclaimer: "The application does not provide ready-made betting tips, but gives you relevant information that you can use along with your own judgment.",
                    importantToKnow: "Important to know:",
                    aiDevelopmentNotice: "Sigurica AI is still under development. We are actively working on new features and improving the accuracy of analyses. Every week we add new data sources, algorithms, and improvements to provide you with the highest quality content.",
                    aiAnalysisInfo: "We use advanced artificial intelligence models and large-scale data processing to provide you with a clear, concise analysis of each match.",
                    registeredUsersBenefits: "Registered users get access to a higher number of daily analyses, as well as more precise insights and advanced features not available to anonymous users.",

                    // Predefined Page
                    mustBeLogin: "This premium feature is available only for members. Please log in.",
                    noMatchesToday: "No recommendations for today. Please come back tomorrow.",
                    predefinedLeaguesAnalyticsText: "Every day we analyze and calculate with the help of artificial intelligence which matches have the highest chance of a successful outcome for that day.",
                    predictability: "Predictability:",
                }
            },

        }
    });

export default i18n;
